<template>
  <div class="grid">
    <div class="grid__col--12 mix__chart mix__chart--mfg">
      <table class="pieTable">

        <tr class="pieTable__header">
          <th class="pieTable__header pieTable__header--key" colspan="3">PRODUCT</th>
          <th class="pieTable__header pieTable__header--value">Units Sold</th>
        </tr>
        <tbody>
          <Product v-for="(product, index) in products" :rank="index + indexOffset" :key="index" :product="product"></Product>
        </tbody>
      </table>
    </div>

  </div> <!-- END grid -->
</template>

<script>
  import Product from './Product.vue';

  export default {
    name: 'Products',
    components: {
      Product,
    },
    props: ['products', 'indexOffset'],
  }
</script>

<style lang="scss" scoped>

  .pieTable__value {
    text-align: right;
    color: $dove-grey;
    font-weight: 600;
  }

  .pieTable {
    width: 100%;
    @include e('header') {
      color: $dove-grey;
      font-weight: 600;
      font-size: em(14px);
      @include m('value') {
        text-align: right;
      }
    }
    @include e('key') {
      color: $dove-grey;
    }

    tbody {
      border-top: 1px solid $mystic;
      border-bottom: 1px solid $mystic;
    }

    tbody:before {
      content: '';
      display: block;
      height: 5px;
    }

    th {
      font-weight: 500;
      padding-bottom: 5px;
    }
  }
</style>
